import type { ComponentRef } from 'react';
import { forwardRef } from 'react';

import type { IllustrationLayoutProps } from '../Layout';
import { BaseIllustrationLayout } from '../Layout';

const IllustrationLayout = forwardRef<ComponentRef<'div'>, IllustrationLayoutProps>(
  ({ children, ...props }, ref) => {
    return (
      <BaseIllustrationLayout ref={ref} {...props}>
        {children}
      </BaseIllustrationLayout>
    );
  },
);

export default IllustrationLayout;
